<template>
  <div id="index">
    <div class="news">
      <!-- 轮播图|片 -->
      <Banner />
      <!-- 即将上线/去登录 -->
      <IndexUpcoming :data_upcoming="upcoming_o.list" :data_userId="userId" />
    </div>
    <div class="rows" style="height: 294px">
      <div class="itemTitle">
        <h3>最新课程</h3>

        <!-- 收费课程切换按钮 -->
        <ul class="curriculums_btn">
          <li @click="newestCoursePrev">
            <LeftOutlined />
          </li>
          <li @click="newestCourseNext">
            <RightOutlined />
          </li>
        </ul>
      </div>
      <a-carousel ref="newestCourse" :dots="false">
        <curriculum
                data_lineLen="5"
                :data_list="item"
                v-for="(item, index) in newestCourse_o.list"
                :key="index"
        />
      </a-carousel>
    </div>
    <div class="rows" style="height: 294px">
      <div class="itemTitle">
        <h3>收费课程</h3>

        <!-- 收费课程切换按钮 -->
        <ul class="curriculums_btn">
          <li @click="curriculumslePrev">
            <LeftOutlined />
          </li>
          <li @click="curriculumsleNext">
            <RightOutlined />
          </li>
        </ul>
      </div>
      <a-carousel ref="curriculums" :dots="false">
        <curriculum
          data_lineLen="5"
          :data_list="item"
          v-for="(item, index) in excellentCourse_o.list"
          :key="index"
        />
      </a-carousel>
    </div>
    <div class="rows" style="height: 228px">
      <!-- 标题 -->
      <div class="itemTitle">
        <h3>讲师大全</h3>
        <div class="specialist_more" @click="toMoreTeacher">查看更多</div>
      </div>
      <!-- 专家轮播 -->
      <!--      <div class="specialist">-->
      <!--        <b @click="specialistPrev">-->
      <!--          <LeftOutlined />-->
      <!--        </b>-->
      <!--        <div class="swiper-container">-->
      <!--          <div class="swiper-wrapper">-->
      <!--            <div-->
      <!--              v-for="(item, index) in speaker_o.list"-->
      <!--              :class="`swiper-slide ${-->
      <!--                index === speaker_o.active ? 'active' : ''-->
      <!--              }`"-->
      <!--              :key="index"-->
      <!--              @click="getFamousSpeakerCourses_fn(item.id, index)"-->
      <!--            >-->
      <!--              <img-->
      <!--                :src="item.avatar ? item.avatar : defaule_avatar"-->
      <!--                :alt="item.name"-->
      <!--              />-->
      <!--              <div>-->
      <!--                <h5>{{ item.name }}</h5>-->
      <!--                <span>{{ item.unit }}</span>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <b @click="specialistNext">-->
      <!--          <RightOutlined />-->
      <!--        </b>-->
      <!--      </div>-->
      <!--      <div :class="`course ${speaker_o.course.active ? 'active' : ''}`">-->
      <!--        <Curriculum data_lineLen="4" :data_list="speaker_o.course.list" />-->
      <!--      </div>-->

      <!-- 专家两行 -->
      <div class="talker">
        <div
                v-for="(item, index) in speaker_o.list"
                class="talkerItem"
                :key="index"
                @mousemove="getFamousSpeakerCourses_fn(item.id, index)"
                @click="toPersonal(item)"
        >
          <img
                  :src="item.avatar ? item.avatar : defaule_avatar"
                  :alt="item.name"
          />
          <div>
            <h5>{{ item.name }}</h5>
            <span>{{ item.unit }}</span>
            {{item.oldSpeakerId}}
          </div>

          <!-- 课程 -->
<!--          <ul :class="`talkerCourse len9`">-->
<!--            <template>123-->
<!--              <li @click="toCourse(1)">-->
<!--                <img src="" alt="">-->
<!--                &lt;!&ndash; 名师课程 &ndash;&gt;-->
<!--                <span>111</span>-->
<!--                &lt;!&ndash; hover &ndash;&gt;-->
<!--                <div><span>222</span></div>-->
<!--              </li>-->
<!--            </template>-->
<!--          </ul>-->
<!--          <p class="loading talkerCourse">请稍后...</p>-->

          <ul v-if="speaker_o.course.list[index] && speaker_o.course.list[index].length"
              :class="`${speaker_o.course.list[index].length>1?'len3':''}
              ${speaker_o.course.list[index].length==6?'len9':''}
              ${speaker_o.course.list[index].length>6?'len10':''}
              talkerCourse`">
              <li v-for="(v,i) in speaker_o.course.list[index]" :key="i" @click.stop="toCourse(v.id)">
                <img :src="v.cover" alt="">
                <!-- 名师课程 -->
<!--                <span>{{v.name}}</span>-->
                <!-- hover -->
                <div><span>{{v.name}}</span></div>
              </li>
          </ul>
          <p v-else class="loading talkerCourse">请稍后...</p>
        </div>
        <div class="talkerItem fill" v-for="(item,index) in replenish_dom_cputd(speaker_o.list.length,4)" :key="index"></div>
      </div>


    </div>
    <div class="rows">
      <!-- 标题 -->
      <div class="itemTitle">
        <h3>免费课程</h3>
        <div class="specialist_change" @click="freeCourseChange_fn">换一换</div>
      </div>
      <Curriculum data_lineLen="5" :data_list="freeCourse_o.list" />
    </div>
  </div>
</template>

<script>
import { Carousel, Image } from "ant-design-vue";
import { LeftOutlined, RightOutlined } from "@ant-design/icons-vue";
import Curriculum from "@c/course/Curriculum";
import IndexUpcoming from "@c/course/IndexUpcoming";
import Banner from "@c/course/Banner";
// import Swiper from "swiper";
// import "swiper/swiper.scss";
import { getUserId,replenish_dom,isBrainMedPC } from "@/utils/methods.js";
import {
  getCoursePageTypeCourses,
  getPcFreeCourseList,
  getHomepageShowSpeakers,
  getFamousSpeakerCourses,
  getPcUserCourses,
} from "@/api";
import { btn_click } from "../../utils/AnalysysAgent";
import Cookie from "js-cookie";

export default {
  name: "index",
  components: {
    [Carousel.name]: Carousel,
    [Image.name]: Image,
    LeftOutlined,
    RightOutlined,
    Curriculum,
    IndexUpcoming,
    Banner,
  },
  computed:{
    replenish_dom_cputd() {
      return (arr, len) => {
        return replenish_dom(arr, len);
      }
    },
  },
  data() {
    return {
      defaule_avatar: require("@a/img/default_avatar.png"),
      userId: getUserId(),
      // userId:"",
      // 我的课程
      upcoming_o: {
        list: [],
        pageNo: 1,
        pageSize: 2,
      },
      // 最新课程
      newestCourse_o: {
        list: [],
        activePageNo:1, // 当前页数
        pageNo: 1,
        pageSize: 5,
        coursePageType: "N",
      },
      // 收费课程列表
      excellentCourse_o: {
        list: [],
        pageNo: 1,
        pageSize: 50,
        coursePageType: "M",
      },
      // 免费课程
      freeCourse_o: {
        list: [],
        pageSize: 10,
      },
      // 名师列表
      speaker_o: {
        list: [],
        pageSize: 8,
        course: {
          list: {},
          pageNo: 1,
          pageSize: 50,
        },
        oldSpeakerId: true // 防止mousemove多次触发
      },
    };
  },
  methods: {
    // 个人中心
    toPersonal(item){
      if(item.systemUserId){
        let href = '/user-center?profileUserId=' + item.systemUserId
        if(isBrainMedPC()){
          href += '&token=' + Cookie.get('wtoken')
        }
        window.open(href, '_blank');
      }
    },
    // 最新课程下一页
    newestCourseNext() {
      // this.$refs.newestCourse.next();
      this.getNewestCourseCourse_fn();
    },
    // 最新课程上一页
    newestCoursePrev() {
      this.$refs.newestCourse.prev();
      this.newestCourse_o.activePageNo--;
    },
    // 收费课程下一页
    curriculumsleNext() {
      this.$refs.curriculums.next();
    },
    // 收费课程上一页
    curriculumslePrev() {
      this.$refs.curriculums.prev();
    },
    toMoreTeacher() {
      btn_click("讲师大全-查看更多",document.title)
      this.$router.push("/specialist");
    },
    // // 设置专家列表轮播
    // expertSwiper() {
    //   this.speaker_o.active = 0; // 初始化要赋值
    //   this.speaker_o.expertSwiperObg = new Swiper(".swiper-container", {
    //     slidesPerView: 4.36, // 显示的个数
    //     spaceBetween: 18, // item marginRight值
    //   });
    // },
    // // 专家列表下一页
    // specialistNext() {
    //   this.speaker_o.expertSwiperObg.slideNext();
    // },
    // // 专家列表上一页
    // specialistPrev() {
    //   this.speaker_o.expertSwiperObg.slidePrev();
    // },

    // 我的课程
    getComingOnlineCourses_fn() {
      getPcUserCourses({
        userId: this.userId,
        pageNo: this.upcoming_o.pageNo,
        pageSize: this.upcoming_o.pageSize,
      }).then((res) => {
        console.log("我的课程", res);
        if (res.data.code === 1) {
          this.upcoming_o.list = res.data.list;
        }
      });
    },
    // 获取最新课程
    getNewestCourseCourse_fn() {
      if(this.newestCourse_o.activePageNo>=this.newestCourse_o.pageNo){
        getCoursePageTypeCourses({
          pageNo: this.newestCourse_o.pageNo,
          pageSize: this.newestCourse_o.pageSize,
          coursePageType: this.newestCourse_o.coursePageType,
          userId: "", // 可为空
          display: 'T'
        }).then((res) => {
          if (res.data.code === 1) {
            var fiveContent = []; // 这个用来存放每五个组成一个数组
            res.data.list.map((v, i) => {
              // [5]: 每行显示5个
              if (i > 0 && i % 5 === 0) {
                this.newestCourse_o.list.push(fiveContent);
                fiveContent = [];
              }
              fiveContent.push(v);
            });
            this.newestCourse_o.list.push(fiveContent);
            console.log("最新课程", this.newestCourse_o.list,'页数',this.newestCourse_o.pageNo);
            // 页数加一准备下次请求
            this.newestCourse_o.pageNo++;
            // 切换到下一页
            this.$refs.newestCourse.next();
            // 当前页数
            this.newestCourse_o.activePageNo++;
          }
        });
      }else{
        // 切换到下一页
        this.$refs.newestCourse.next();
        // 当前页数
        this.newestCourse_o.activePageNo++;
      }
    },
    // 获取收费课程  推荐课程（付费）
    getExcellentCourse_fn() {
      getCoursePageTypeCourses({
        pageNo: this.excellentCourse_o.pageNo,
        pageSize: this.excellentCourse_o.pageSize,
        coursePageType: this.excellentCourse_o.coursePageType,
        userId: "", // 可为空
        display: 'T'
      }).then((res) => {
        if (res.data.code === 1) {
          var fiveContent = []; // 这个用来存放每五个组成一个数组
          res.data.list.map((v, i) => {
            // [5]: 每行显示5个
            if (i > 0 && i % 5 === 0) {
              this.excellentCourse_o.list.push(fiveContent);
              fiveContent = [];
            }
            fiveContent.push(v);
          });
          this.excellentCourse_o.list.push(fiveContent);
          console.log("收费课程", this.excellentCourse_o.list);
        }
      });
    },
    // 免费课程换一换
    freeCourseChange_fn() {
      this.getFreeCourse_fn();
    },
    // 获取免费课程
    getFreeCourse_fn() {
      getPcFreeCourseList({
        limit: this.freeCourse_o.pageSize,
      }).then((res) => {
        if (res.data.code === 1) {
          console.log("免费课程", res.data);
          this.freeCourse_o.list = res.data.list;
        }
      });
    },
    // 名师列表
    getSpeakerList_fn() {
      getHomepageShowSpeakers({
        limit: this.speaker_o.pageSize,
      }).then((res) => {
        if (res.data.code === 1) {
          console.log("名师列表", res.data);
          this.speaker_o.list = res.data.list;
        }
      });
    },
    // 根据讲师获取课程
    getFamousSpeakerCourses_fn(speakerId, index) {
      // 防止多次触发
      if(this.speaker_o.oldSpeakerId === speakerId){
        return;
      }else{
        this.speaker_o.oldSpeakerId = speakerId;
      }
      // 判断是否已获取过
      if(this.speaker_o.course.list[index]){
        return;
      }
      getFamousSpeakerCourses({
        pageNo: this.speaker_o.course.pageNo,
        pageSize: this.speaker_o.course.pageSize,
        speakerId: speakerId,
        display: 'T'
      }).then((res) => {
        if (res.data.code === 1) {
          console.log("名师下的课程", res.data.list);
          this.speaker_o.course.list[index] = res.data.list;
        }
      });
    },
    toCourse(id){
      const routeLink = this.$router.resolve({
        path:  '/pages/coursePlay/coursePlay',
        query: {
          courseId: id
        }
      })
      window.open(routeLink.href, '_blank');
      // this.$router.push('/pages/coursePlay/coursePlay?courseId=' + id);
    },
  },
  mounted() {
    document.title = '云课堂';
    this.getNewestCourseCourse_fn() // 获取最新课程
    this.getExcellentCourse_fn(); // 获取收费课程  推荐课程（付费）
    this.getFreeCourse_fn(); // 获取免费课程
    this.getSpeakerList_fn(); // 名师列表
    this.getComingOnlineCourses_fn(); // 即将上线
  },
};
</script>

<style scoped lang="scss">
#index {
  @extend %safetyWidth;
  display: flex;
  flex-direction: column;
}

.news {
  width: 100%;
  margin: 0 0 20px;
  display: flex;
}

.rows {
  width: 100%;
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  position: relative;
  /*overflow: hidden;*/
  flex: 0 0 auto;

  & > * {
    flex: 0 0 auto;
  }

  /* 标题 */
  .itemTitle {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    & > h3 {
      font-size: 22px;
      @extend %blodFont;
    }

    /* 查看更多 */
    .specialist_more {
      font-size: 12px;
      color: $theme_blue;
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-left: 28px;

      &:after {
        content: "";
        display: inline-block;
        width: 0;
        height: 0;
        border-top: 3px solid transparent;
        border-left: 6px solid $theme_blue;
        border-bottom: 3px solid transparent;
        margin-left: 3px;
      }
    }
    /* 换一换 */
    .specialist_change {
      font-size: 12px;
      color: $theme_blue;
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-left: 28px;
      border: 1px solid $theme_blue;
      border-radius: 10px;
      padding: 0 6px;

      /*      &:after {
        content: "";
        display: inline-block;
        width: 0;
        height: 0;
        border-top: 3px solid transparent;
        border-left: 6px solid $theme_blue;
        border-bottom: 3px solid transparent;
        margin-left: 3px;
      }*/
    }

    /* 收费课程切换按钮 */
    .curriculums_btn {
      display: flex;
      user-select: none;
      margin-left: auto;

      li {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        color: #fff;
        background: rgba(102, 102, 102, 0.6);
        transition: all 0.3s;
        text-align: center;
        cursor: pointer;
        flex: 0 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;

        &:hover {
          background: rgba(5, 129, 206, 0.6);
        }

        &:first-of-type {
          margin-right: 10px;
        }
      }
    }
  }
}

/* 讲师大全专家列表 */
.specialist {
  display: flex;
  flex: 0 0 auto;

  /* 按钮样式 */
  b {
    width: 36px;
    line-height: 78px;
    border-radius: 6px;
    background: #fff;
    font-size: 26px;
    color: #a7a7a7;
    text-align: center;
    cursor: pointer;
    user-select: none;

    &:hover {
      color: $theme_blue;
    }
  }



  /* 专家列表swiper */
  .swiper-container {
    flex: 1;
    width: 300px;
    margin: 0 10px;
    padding: 5px;

    .swiper-slide {
      width: 240px;
      height: 78px;
      border-radius: 6px;
      padding: 0 12px;
      display: flex;
      align-items: center;
      flex: 0 0 auto;
      cursor: pointer;
      border: 1px solid transparent;
      @extend %defaultBg;

      &.active {
        border: 1px solid #0581ce;
        h5,
        span {
          color: #0581ce;
        }
      }

      &:hover {
        h5,
        span {
          color: #0581ce;
        }
      }

      img {
        width: 50px;
        height: 50px;
        margin-right: 8px;
        border-radius: 50%;
        overflow: hidden;
        object-fit: cover;
      }

      div {
        display: flex;
        flex-direction: column;
        flex: 1;
        width: 0;

        h5 {
          font-size: 18px;
        }

        span {
          font-size: 14px;
          color: #8a8a8a;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}

.talker {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, auto);
  gap: 10px;

  .talkerItem{
    @extend %defaultBg;
    width: 275px;
    height: 78px;
    border-radius: 6px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    border: 1px solid transparent;

    &>img {
      width: 50px;
      height: 50px;
      margin-right: 8px;
      border-radius: 50%;
      overflow: hidden;
      object-fit: cover;
    }

    &>div {
      display: flex;
      flex-direction: column;
      flex: 1;
      width: 0;

      &>h5 {
        font-size: 18px;
      }

      &>span {
        font-size: 14px;
        color: #8a8a8a;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    position: relative;

    &:hover::after, &:hover .talkerCourse {
      visibility: visible;
      opacity: 1;
      transition-delay: 0.2s;
    }

    &::after {
      content: '';
      position: absolute;
      top: 66px;
      left: 26px;
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 12px solid #313131;
      visibility: hidden;
      opacity: 0;
      transition: all .2s;
      transition-delay: .2s;
    }

    .talkerCourse {
      top: 78px;
      left: 0;
      background: rgba(49, 49, 49, 0.85);
      padding: 5px;
      border-radius: 6px;
      position: absolute;
      z-index: 10;
      display: flex;
      flex-wrap: wrap;
      visibility: hidden;
      opacity: 0;
      transition: all .2s;
      transition-delay: .2s;
      scrollbar-width: none; /* firefox */
      -ms-overflow-style: none; /* IE 10+ */

      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
        width: 0;
      }

      &.len3 {
        width: 310px;
      }

      &.len9 {
        height: 310px;
      }

      &.len10 {
        height: 280px;
        overflow: auto;
      }

      &::-webkit-scrollbar {
        display: none;
      }

      li {
        margin: 5px;
        border-radius: 6px;
        overflow: hidden;
        position: relative;
        flex: 0 0 auto;

        img {
          width: 140px;
          height: 75px;
        }

        & > span {
          position: absolute;
          padding: 0 10px;
          color: #fff;
          width: 100%;
          left: 0;
          right: 0;
          bottom: 10px;
          margin: auto;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }

        div {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          background: rgba(0, 0, 0, 0.7);
          color: #fff;
          padding: 0 10px;
          display: flex;
          align-items: center;
          opacity: 0;
          transition: all .3s;

          span {
            font-size: 16px;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }

        &:hover div {
          opacity: 1;
        }
      }
    }
  }
  .loading {
    color:#fff;
    line-height: 60px;
    width: 100px;
    justify-content: center;
  }
}

/* 讲师大全专家课程 */
.course {
  margin-top: 20px;
  visibility: hidden;
  opacity: 0.3;
  transition: all 0.2s; /* 这里的时间要和js中this.speaker_o.course.list等待的时间最好一致 */
  flex: 0 0 auto;

  &.active {
    visibility: visible;
    opacity: 1;
  }
}

.fill {
  background: transparent!important;
  height: 0!important;
  margin:0!important;
  border:none!important;
}
</style>
